var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questionTask" },
    [
      _c("van-nav-bar", {
        attrs: {
          fixed: "",
          placeholder: "",
          "safe-area-inset-top": "",
          title: "我的任务",
          "left-text": "",
          "right-text": ""
        },
        on: {
          "click-left": _vm.handleClickLeft,
          "click-right": _vm.handleClickRight
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "questionTask_tabs" },
        _vm._l(_vm.tabList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              class:
                item.value === _vm.checkedTab
                  ? "questionTask_tabs_item active"
                  : "questionTask_tabs_item",
              on: {
                click: function() {
                  return _vm.handleSlectTab(item.value)
                }
              }
            },
            [_vm._v("\n\t\t\t" + _vm._s(item.name) + "\n\t\t")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "questionTask_list" },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.pages.page >= _vm.pages.totalPages,
                "finished-text": "没有更多了"
              },
              on: { load: _vm.fetchList },
              model: {
                value: _vm.listLoading,
                callback: function($$v) {
                  _vm.listLoading = $$v
                },
                expression: "listLoading"
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "questionTask_item",
                  on: {
                    click: function() {
                      return _vm.handleToRecord(item.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "questionTask_item_main" }, [
                    _c("div", { staticClass: "questionTask_item_main_info" }, [
                      _c(
                        "div",
                        { staticClass: "questionTask_item_main_info_title" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(item.title) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "questionTask_item_main_info_num" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(item.description) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "questionTask_item_main_info_status" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.computedTaskStatusName(item.status)) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "questionTask_item_main_info_btn" },
                      [_vm._v("\n\t\t\t\t\t\t详情\n\t\t\t\t\t")]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("tabBar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdb50162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdb50162","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/question/task/index.vue
// module id = null
// module chunks = 